__turbopack_context__.v({
  "bottom": "PlasmicLoginForm-module__zBxpgq__bottom",
  "desc": "PlasmicLoginForm-module__zBxpgq__desc",
  "form": "PlasmicLoginForm-module__zBxpgq__form",
  "header": "PlasmicLoginForm-module__zBxpgq__header",
  "heading": "PlasmicLoginForm-module__zBxpgq__heading",
  "img__m64Y8": "PlasmicLoginForm-module__zBxpgq__img__m64Y8",
  "img__uwgCm": "PlasmicLoginForm-module__zBxpgq__img__uwgCm",
  "label": "PlasmicLoginForm-module__zBxpgq__label",
  "label7": "PlasmicLoginForm-module__zBxpgq__label7",
  "label9": "PlasmicLoginForm-module__zBxpgq__label9",
  "line": "PlasmicLoginForm-module__zBxpgq__line",
  "link": "PlasmicLoginForm-module__zBxpgq__link",
  "link___5Pv45": "PlasmicLoginForm-module__zBxpgq__link___5Pv45",
  "logInBtn": "PlasmicLoginForm-module__zBxpgq__logInBtn",
  "loginForm": "PlasmicLoginForm-module__zBxpgq__loginForm",
  "loginFormResources": "PlasmicLoginForm-module__zBxpgq__loginFormResources",
  "loginFormSecurity": "PlasmicLoginForm-module__zBxpgq__loginFormSecurity",
  "logo": "PlasmicLoginForm-module__zBxpgq__logo",
  "multiFactorAuthModal": "PlasmicLoginForm-module__zBxpgq__multiFactorAuthModal",
  "notice": "PlasmicLoginForm-module__zBxpgq__notice",
  "onChangeProvider": "PlasmicLoginForm-module__zBxpgq__onChangeProvider",
  "password": "PlasmicLoginForm-module__zBxpgq__password",
  "passwordInput": "PlasmicLoginForm-module__zBxpgq__passwordInput",
  "passwordLabels": "PlasmicLoginForm-module__zBxpgq__passwordLabels",
  "passwordProvider": "PlasmicLoginForm-module__zBxpgq__passwordProvider",
  "root": "PlasmicLoginForm-module__zBxpgq__root",
  "section": "PlasmicLoginForm-module__zBxpgq__section",
  "serviceMessage": "PlasmicLoginForm-module__zBxpgq__serviceMessage",
  "spinnerIcon": "PlasmicLoginForm-module__zBxpgq__spinnerIcon",
  "svg___3R9Dl": "PlasmicLoginForm-module__zBxpgq__svg___3R9Dl",
  "svg__c3Szl": "PlasmicLoginForm-module__zBxpgq__svg__c3Szl",
  "svg__sMgbk": "PlasmicLoginForm-module__zBxpgq__svg__sMgbk",
  "svg__u8Fqz": "PlasmicLoginForm-module__zBxpgq__svg__u8Fqz",
  "text": "PlasmicLoginForm-module__zBxpgq__text",
  "title": "PlasmicLoginForm-module__zBxpgq__title",
  "usernameInput": "PlasmicLoginForm-module__zBxpgq__usernameInput",
  "usernameProvider": "PlasmicLoginForm-module__zBxpgq__usernameProvider",
  "usernameWrapper": "PlasmicLoginForm-module__zBxpgq__usernameWrapper",
  "wrapper": "PlasmicLoginForm-module__zBxpgq__wrapper",
});
